import { render, staticRenderFns } from "./salsend.vue?vue&type=template&id=5a458084&scoped=true&"
import script from "./salsend.vue?vue&type=script&lang=js&"
export * from "./salsend.vue?vue&type=script&lang=js&"
import style0 from "./salsend.vue?vue&type=style&index=0&id=5a458084&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a458084",
  null
  
)

export default component.exports